import { render, staticRenderFns } from "./ProductImageThumbnail.vue?vue&type=template&id=7a20a7ac&scoped=true&"
import script from "./ProductImageThumbnail.vue?vue&type=script&lang=js&"
export * from "./ProductImageThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageThumbnail.vue?vue&type=style&index=0&id=7a20a7ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a20a7ac",
  null
  
)

export default component.exports